$.fn.bannerSlider = function (e) {
    function t() {
        var n = $(r[o]);
        o = (o + 1) % i;
        var a = $(r[o]);
        n.css({
            "z-index": 3
        }).delay(e.delay).fadeOut(e.duration, t), a.css({
            "z-index": 2
        }).show()
    }
    var n = {
        delay: 2e3,
        duration: 500
    }, r = this,
        i = r.length,
        o = 0;
    return e = $.extend({}, n, e), t(), this
}